'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deserializeLeaderboard = exports.fetchLeaderboard = undefined;

var _last = require('lodash/last');

var _last2 = _interopRequireDefault(_last);

var _client = require('../../../utils/client');

var _params = require('../../../utils/params');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @function fetches supporter pages ranked by funds raised
 */
var fetchLeaderboard = exports.fetchLeaderboard = function fetchLeaderboard() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _params.required)();

  var transforms = {
    type: function type(val) {
      return val === 'team' ? 'teams' : val === 'group' ? 'groups' : 'individuals';
    }
  };

  var mappings = {
    excludePageIds: 'exclude_page_ids',
    groupID: 'group_id',
    maxAmount: 'max_amount_cents',
    minAmount: 'min_amount_cents'
  };

  return (0, _client.get)('api/v2/search/pages_totals', params, {
    mappings: mappings,
    transforms: transforms
  }).then(function (response) {
    return response.results;
  });
};

/**
 * @function a default deserializer for leaderboard pages
 */
var deserializeLeaderboard = exports.deserializeLeaderboard = function deserializeLeaderboard(result, index) {
  if (result.page) {
    return deserializePage(result.page, index, result);
  } else if (result.team) {
    return deserializePage(result.team, index, result);
  } else if (result.group) {
    return deserializeGroup(result, index);
  }
};

var deserializePage = function deserializePage(item, index, baseItem) {
  return {
    charity: item.charity_name,
    charityLogo: item.charity_logo_url,
    currency: item.amount.currency.iso_code,
    currencySymbol: item.amount.currency.symbol,
    donationCount: baseItem.count,
    donationUrl: item.donation_url,
    groups: item.group_values,
    id: item.id,
    image: item.image.large_image_url,
    name: item.name,
    offline: (item.offline_amount_cents || 0) / 100,
    position: index + 1,
    raised: item.amount.cents / 100,
    slug: item.url && (0, _last2.default)(item.url.split('/')),
    subtitle: item.charity_name,
    target: item.target_cents / 100,
    totalDonations: baseItem.count,
    url: item.url
  };
};

var deserializeGroup = function deserializeGroup(item, index) {
  return {
    count: item.count,
    id: item.group.id,
    name: item.group.value,
    position: index + 1,
    raised: item.amount_cents / 100
  };
};


//////////////////
// WEBPACK FOOTER
// ../~/supporticon/api/leaderboard/everydayhero/index.js
// module id = 1318
// module chunks = 0